import React from 'react';
import './styles/style.scss';
import Confetti from 'react-confetti';

const ThankYou = ({ siteInfo }) => {
  return (
    <>
      <Confetti />
      <div style={{ textAlign: 'center' }}>
        <h1 className="title">Thank you!</h1>
        <p>We will be in touch soon!</p>
      </div>
    </>
  )
}

export default ThankYou